import React, { Component } from "react";
import Swal from 'sweetalert2';
import { Col, Button, Form, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, Row } from 'reactstrap';
import { api_url } from "./globalFunction/global_string";
import "./Form.css";
import { SiteTitle } from "./SiteTitle";


export class FormModifyinformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      account_M: '',
      password_M: '',
      name_M: '',
      email_M: '',
      fullName_R: '',
      Net_M: '',
      serviceUnit_M: '',
      serviceOffice_M: '',
      phoneExtension_M: '',
      title_M: '',
      loggedIn: false,
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      showModal: false,
      passwordMessage: '',
      isChangeEmailModalOpen: false,
      newEmail: "",
      verificationCode: "",
      isButtonDisabled: false,
      remainingTime: 60,
    };
  }

  openChangePasswordModal = () => {
    this.setState({ showModal: true });
  };

  closeChangePasswordModal = () => {
    this.setState({ showModal: false });
  };
  openChangeEmailModal = () => {
    this.setState({ isChangeEmailModalOpen: true });
  };

  closeChangeEmailModal = () => {
    this.setState({ isChangeEmailModalOpen: false });
  };

  handleEmailChange = (event) => {
    this.setState({ newEmail: event.target.value });
  };

  handleCodeChange = (event) => {
    this.setState({ verificationCode: event.target.value });
  };
  sendVerificationEmail = async () => {
    let apiUrl = api_url + "/api/Auth/SendRegisterByEmail";
    const formData = new FormData();
    formData.append("E_mail", this.state.newEmail);
    this.setState({ isButtonDisabled: true, remainingTime: 60 });
    const timer = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.remainingTime <= 1) {
          clearInterval(timer);
          return { isButtonDisabled: false, remainingTime: 60 };
        }
        return { remainingTime: prevState.remainingTime - 1 };
      });
    }, 1000);
    fetch(apiUrl,
      {
        method: "POST",
        body: formData
      })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          console.error('Error parsing JSON:', error);
          throw error
        };
      })
      .then(data => {
        let arr_status = [String(data.statusCode), data.row, data.detail] //api 回傳判斷
        //console.log("data:", data, arr_status);
        switch (arr_status[0]) {
          case "200":
            Swal.fire({
              icon: 'success',
              title: '【驗證碼已發送到您的郵箱】',
              text: '恭喜'
            });
            break;
          case "400":
            Swal.fire({
              icon: 'error',
              title: `【${data.row}】`,
              text: 'sorry'
            });
            break;
          default:
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  fetchUserData = () => {
    let api = api_url + "/api/Auth/GetModfityUser";
    fetch(api,
      {
        method: "GET",
        headers: {
          "Authorization": localStorage.getItem('accessToken'),
        },
      })
      .then(response => response.json())
      .then(data => {
        if (data.statusCode === 200) {
          this.setState({
            account_M: data.row.user_id,
            email_M: data.row.e_mail,
            fullName_R: data.row.user_name,
            Net_M: data.row.servicenet,
            serviceUnit_M: data.row.serviceUnit,
            serviceOffice_M: data.row.serviceOffice,
            phoneExtension_M: data.row.phoneExtension,
            title_M: data.row.title,
          });
        }
      })
      .catch(error => { console.error('Error:', error); });
  }
  componentDidMount() {
    this.fetchUserData();
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  checkPasswordStrength = () => {
    const password = this.state.newPassword;
    let message = '';

    if (password.length < 8) {
      message += '密碼至少需要8個字符。';
    }
    if (!/\d/.test(password)) {
      message += '必須包含至少一個數字。';
    }
    if (!/[a-zA-Z]/.test(password)) {
      message += '必須包含至少一個英文字母。';
    }
    if (!/[\W_]/.test(password)) {
      message += '必須包含至少一個特殊符號。';
    }
    this.setState({ passwordMessage: message });
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      if (name === 'newPassword') {
        this.checkPasswordStrength();
      }
    });
  };
  validatePasswordChange = () => {
    const { oldPassword, newPassword, confirmNewPassword } = this.state;
    if (newPassword !== confirmNewPassword) {
      Swal.fire({
        icon: 'error',
        title: '【密碼不匹配】',
        text: '新密碼和確認新密碼不一致'
      });
      return;
    }
    if (this.state.passwordMessage) {
      Swal.fire({
        icon: 'error',
        title: '【密碼強度不足】',
        text: this.state.passwordMessage
      });
      return;
    }
    let apiUrl = api_url + "/api/Async/PutUserPassword";
    const formData = new FormData();
    formData.append("user_id", this.state.account_M);
    formData.append("oldPassword", this.state.oldPassword);
    formData.append("newPassword", this.state.newPassword);
    fetch(apiUrl,
      {
        method: "POST",
        headers: { "Authorization": localStorage.getItem('accessToken') },
        body: formData
      })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          console.error('Error parsing JSON:', error);
          throw error
        };
      })
      .then(data => {
        let arr_status = [String(data.statusCode), data.row, data.detail] //api 回傳判斷
        switch (arr_status[0]) {
          case "200": //將Token寫入browser
            Swal.fire({
              icon: 'success',
              title: '【修改成功】',
              text: '恭喜'
            });
            this.closeChangePasswordModal();
            break;
          case "400":
            Swal.fire({
              icon: 'success',
              title: `${data.row}`,
              text: '修改失敗'
            });
            break;
          case "500":
            window.location.href = '404'
            break;
          default:
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };
  updateEmail = () => {

    let apiUrl = api_url + "/api/Async/ResetEmail";
    const formData = new FormData();
    formData.append("e_mail", this.state.newEmail);
    formData.append("verificationCode", this.state.verificationCode);
    formData.append("user_id", this.state.account_M);
    fetch(apiUrl,
      {
        method: "POST",
        headers: { "Authorization": localStorage.getItem('accessToken') },
        body: formData
      })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          console.error('Error parsing JSON:', error);
          throw error
        };
      })
      .then(data => {
        let arr_status = [String(data.statusCode), data.row, data.detail]
        switch (arr_status[0]) {
          case "200":
            Swal.fire({
              icon: 'success',
              title: '【修改成功】',
              text: '恭喜'
            })
            this.setState({
              isChangeEmailModalOpen: false,
              newEmail: '',
              verificationCode: ''
            });
            this.fetchUserData();
            break;
          case "400":
            Swal.fire({
              icon: 'error',
              title: `${data.row}`,
              text: 'sorry'
            });
            break;
          case "500":
            window.location.href = '404'
            break;
          default:
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };

  handleRegister = (e) => {
    e.preventDefault();

    let apiUrl = api_url + "/api/Async/PutUserModfity";
    const formData = new FormData();
    formData.append("user_id", this.state.account_M);
    formData.append("User_name", this.state.fullName_R);
    formData.append("E_mail", this.state.email_M);
    formData.append("servicenet", this.state.Net_M);
    formData.append("serviceUnit", this.state.serviceUnit_M);
    formData.append("serviceOffice", this.state.serviceOffice_M);
    formData.append("phoneExtension", this.state.phoneExtension_M);
    formData.append("title", this.state.title_M !== undefined ? this.state.title_M : null);
    fetch(apiUrl,
      {
        method: "POST",
        headers: { "Authorization": localStorage.getItem('accessToken') },
        body: formData
      })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          console.error('Error parsing JSON:', error);
          throw error
        };
      })
      .then(data => {
        let arr_status = [String(data.statusCode), data.row, data.detail]
        switch (arr_status[0]) {
          case "200":
            Swal.fire({
              icon: 'success',
              title: '【修改成功】',
              text: '恭喜'
            }).then((result) => {
              if (result.isConfirmed) {
                localStorage.setItem("login_user_name", this.state.fullName_R);
                window.dispatchEvent(new Event('loginUserNameChanged'));
              }
            });
            break;
          case "400":
            Swal.fire({
              icon: 'error',
              title: `${data.row}`,
              text: 'sorry'
            });
            break;
          case "500":
            window.location.href = '404'
            break;
          default:
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
  };

  render() {
    return (
      <div>
        <SiteTitle />
        <div className="card mt-5">
          <div className="card-body">
            <h1 id="tableLabel" className='table-title mb-3'>個人資料</h1>
            <Form onSubmit={this.handleRegister}>
              <FormGroup row className="mb-3">
                <Label for="account_M" sm={2} className="text-right">帳號</Label>
                <Col sm={10}>
                  <Input type="text" name="account_M" placeholder="Username" value={this.state.account_M} readOnly className="read-only-input" />
                </Col>
              </FormGroup>
              <FormGroup row className="mb-3">
                <Label for="fullName_R" sm={2} className="text-right">姓名</Label>
                <Col sm={8}>
                  <Input type="text" name="fullName_R" placeholder="王小名" value={this.state.fullName_R} onChange={this.handleChange} required />
                </Col>
              </FormGroup>
              <FormGroup row className="mb-3">
                <Label for="email_M" sm={2} className="text-right">信箱</Label>
                <Col sm={10}>
                  <Input type="email" name="email_M" placeholder="Email" value={this.state.email_M} onChange={this.handleChange} readOnly className="read-only-input" />
                </Col>
              </FormGroup>
              <FormGroup row className="mb-3">
                <Label for="Net_M" sm={2} className="text-right">區網</Label>
                <Col sm={10}>
                  <Input type="text" name="Net_M" placeholder="請填寫對應的區網單位 例如：竹苗區網、中央研究院" value={this.state.Net_M} onChange={this.handleChange} />
                </Col>
              </FormGroup>

              <FormGroup row className="mb-3">
                <Label for="serviceUnit_M" sm={2} className="text-right">服務單位</Label>
                <Col sm={4}>
                  <Input type="text" name="serviceUnit_M" placeholder="國立陽明交通大學" value={this.state.serviceUnit_M} onChange={this.handleChange} required />
                </Col>
                <Label for="serviceOffice_M" sm={2} className="text-right">服務處室</Label>
                <Col sm={4}>
                  <Input type="text" name="serviceOffice_M" placeholder="資訊技術服務中心" value={this.state.serviceOffice_M} onChange={this.handleChange} required />
                </Col>
              </FormGroup>
              <FormGroup row className="mb-3">
                <Label for="phoneExtension_M" sm={2} className="text-right">電話分機</Label>
                <Col sm={10}>
                  <Input type="text" name="phoneExtension_M" placeholder="電話分機(030000000)分機(#123)" value={this.state.phoneExtension_M} onChange={this.handleChange} required />
                </Col>
              </FormGroup>
              <FormGroup row className="mb-3">
                <Label for="title_M" sm={2} className="text-right">職稱</Label>
                <Col sm={10}>
                  <Input type="text" name="title_M" placeholder="組長" value={this.state.title_M} onChange={this.handleChange} />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Col sm={{ size: 10, offset: 2 }}>
                  <Button color="primary" type="submit" onClick={this.validateForm}>修改</Button>
                  <Button color="primary" onClick={this.openChangePasswordModal}>修改密碼</Button>
                  <Button color="secondary" onClick={this.openChangeEmailModal}>修改信箱</Button>
                </Col>
              </FormGroup>
            </Form>
          </div>
        </div>


        <Modal isOpen={this.state.showModal} toggle={this.closeChangePasswordModal}>
          <div className="modal-header">
            <h5 className="modal-title">修改密碼</h5>
            <button type="button" className="close" onClick={this.closeChangePasswordModal}>
              <span>&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <FormGroup>
              <Label for="oldPassword">舊密碼</Label>
              <Input type="password" name="oldPassword" onChange={this.handleChange} required />
            </FormGroup>
            <FormGroup>
              <Label for="newPassword">新密碼</Label>
              <Input type="password" name="newPassword" onChange={this.handleChange} required />
              <div className="text-danger">
                {this.state.passwordMessage}
              </div>
            </FormGroup>
            <FormGroup>
              <Label for="confirmNewPassword">確認新密碼</Label>
              <Input type="password" name="confirmNewPassword" onChange={this.handleChange} required />
            </FormGroup>
          </div>
          <div className="modal-footer">
            <Button color="secondary" onClick={this.closeChangePasswordModal}>取消</Button>
            <Button color="primary" onClick={this.validatePasswordChange}>確認</Button>
          </div>
        </Modal>


        <Modal isOpen={this.state.isChangeEmailModalOpen} toggle={this.closeChangeEmailModal}>
          <ModalHeader toggle={this.closeChangeEmailModal}>修改信箱</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="newEmail">新的信箱</Label>
              <Input type="email" name="newEmail" id="newEmail" placeholder="新的信箱" value={this.state.newEmail} onChange={this.handleEmailChange} />
            </FormGroup>
            <Button
              color="primary"
              onClick={this.sendVerificationEmail}
              disabled={this.state.isButtonDisabled}
            >
              {this.state.isButtonDisabled ? `重新發送(${this.state.remainingTime}s)` : "發送驗證碼"}
            </Button>
            <FormGroup>
              <Label for="verificationCode">驗證碼</Label>
              <Input type="text" name="verificationCode" id="verificationCode" placeholder="請輸入驗證碼" value={this.state.verificationCode} onChange={this.handleCodeChange} />
            </FormGroup>

          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.updateEmail}>儲存</Button>
            <Button color="secondary" onClick={this.closeChangeEmailModal}>取消</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}